if (!customElements.get("gh-upsell-product")) {
  class CartCheckboxUpsell extends HTMLElement {
    constructor() {
      super();

      // Base cart URL
      this.baseUrl = "/cart";

      // Initialize event delegation and state management
      this.initEventDelegation();
      this.updateAllUpsellStates();

      // Listen for cart updates
      document.addEventListener("cartUpdated", this.handleCartUpdate.bind(this));
      document.addEventListener("quantityUpdated", this.updateCartAndDrawer.bind(this));
    }

    initEventDelegation() {
      this.querySelector("#cart-upsell-checkbox")?.addEventListener("change", (event) => {
        if (event.target.id === "cart-upsell-checkbox") {
          const isChecked = event.target.checked;
          const variantId = event.target.getAttribute("data-variant-id");

          if (isChecked) {
            this.addUpsellToCart(variantId);
          } else {
            this.removeUpsellFromCart(variantId);
          }
        }
      });
    }

    updateAllUpsellStates() {
      // Fetch the cart and update all upsell checkboxes (cart and drawer)
      fetch(`${this.baseUrl}.js`)
        .then((response) => response.json())
        .then((cart) => {
          const upsellCheckboxes = document.querySelectorAll("#cart-upsell-checkbox");

          upsellCheckboxes.forEach((checkbox) => {
            const variantId = checkbox.getAttribute("data-variant-id");
            const isInCart = cart.items.some((item) => item.variant_id.toString() === variantId);
            checkbox.checked = isInCart;
          });
        })
        .catch((error) => console.error("Error fetching cart:", error));
    }

    handleCartUpdate() {
      // Debounce updates to prevent flickering
      setTimeout(() => this.updateAllUpsellStates(), 500);
    }

    addUpsellToCart(variantId) {
      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);
      const cart = document.querySelector("cart-drawer");
      if (cart) {
        formData.append(
          "sections",
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }

      fetch(`${this.baseUrl}/add.js`, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          if (response.ok) {
            this.updateCartAndDrawer();
          }

          return response.json();
        })

        .catch((error) => console.error("Error adding upsell product:", error));
    }

    removeUpsellFromCart(variantId) {
      fetch(`${this.baseUrl}.js`)
        .then((response) => response.json())
        .then((cart) => {
          const lineItem = cart.items.find((item) => item.variant_id.toString() === variantId);

          if (!lineItem) return;
          const line = cart.items.indexOf(lineItem) + 1;

          const cartItemsInstance = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
          if (cartItemsInstance && !window.isUpsellRemoving) {
            window.isUpsellRemoving = true;
            cartItemsInstance.updateQuantity(line, 0, null, null);

            setTimeout(() => {
              window.isUpsellRemoving = false;
            }, 2000);
          }
        })
        .catch((error) => console.error("Error fetching cart for upsell removal:", error));
    }

    updateCartAndDrawer() {
      const cartItemsInstance = document.querySelector("cart-items");
      const cartDrawerItemsInstance = document.querySelector("cart-drawer-items");

      // Update both cart and drawer instances
      if (cartDrawerItemsInstance && typeof cartDrawerItemsInstance.onCartDrawerUpdate === "function") {
        cartDrawerItemsInstance.onCartDrawerUpdate();
      }

      // Cart istance
      if (cartItemsInstance && typeof cartItemsInstance.onCartUpdate === "function") {
        cartItemsInstance.onCartUpdate();
      }

      // Update upsell states in both locations
      this.updateAllUpsellStates();
    }
  }

  customElements.define("gh-upsell-product", CartCheckboxUpsell);
}
